import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

const roleOptions = [
  {
    label: 'Physician',
    value: 2,
    key: 'physician'
  },
  {
    label: 'Medical Assistant',
    value: 3,
    key: 'ma'
  },
  {
    label: 'Physician Assistant',
    value: 4,
    key: 'pa'
  },
  {
    label: 'Authorization Specialist',
    value: 5,
    key: 'as'
  },
  {
    label: 'Other',
    value: 5,
    key: 'other'
  }
];

export default function ApproveAccessModal(props) {
  const { show, onHide, accessRequest, onApprove } = props;
  const [selectedRole, setSelectedRole] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    if (!selectedRole) {
      setError('Please select a role');
      return;
    }

    setSubmitting(true);
    setError(null);

    try {
      await onApprove(accessRequest, parseInt(selectedRole));
      // Reset state on success
      setSelectedRole('');
      setError(null);
      onHide();
    } catch (e) {
      setError(e.message || 'Failed to approve access request');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSelectedRole('');
    setError(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Approve Access Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" onClose={() => setError(null)} dismissible>
            <i className="fa fa-fw fa-exclamation-triangle" /> {error}
          </Alert>
        )}
        {accessRequest && (
          <div style={{ marginBottom: '1rem' }}>
            <p>
              <strong>Name:</strong> {accessRequest.requester_first_name}{' '}
              {accessRequest.requester_last_name}
            </p>
            <p>
              <strong>Email:</strong> {accessRequest.requester_email}
            </p>
          </div>
        )}
        <Form.Group>
          <Form.Label>
            <strong>Select Role *</strong>
          </Form.Label>
          <Form.Control
            as="select"
            value={selectedRole}
            onChange={e => setSelectedRole(e.target.value)}
            disabled={submitting}
          >
            <option value="">-- Please select a role --</option>
            {roleOptions.map(role => (
              <option key={role.key} value={role.value}>
                {role.label}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit} disabled={!selectedRole || submitting}>
          {submitting ? 'Approving...' : 'Approve'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
